// extracted by mini-css-extract-plugin
module.exports = {"commonButton":"CommonButton_commonButton__cQlPz","icon":"CommonButton_icon___hAo_","text":"CommonButton_text__rScpU"};